/* eslint-disable import/prefer-default-export */

const FLIP_PREFIX = 'flip_';

/**
 * extracts flip cookies from passed cookies if the value is "true"
 *
 * @export
 * @param {Array[]} [cookies=[]] cookies (from request context)
 * @returns {String[]}
 */
function getEnabledFlips(cookies = []) {
  return Object.entries(cookies).reduce(
    (p, [name, value]) =>
      name.indexOf(FLIP_PREFIX) === 0 && value === 'true' ? p.concat(name) : p,
    []
  );
}

module.exports = {
  FLIP_PREFIX,
  getEnabledFlips
};
